import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import { BrowserRouter } from "react-router-dom";
import jwtEncode from "jwt-encode";
import jwtDecode from "jwt-decode";
import "./App.css";
import "./Static/css/style.css";
import "./Static/css/custom.css";
import { UNO_URL, applicationId, redirectUrl } from "./env";
import { saveConfig } from "./store/slice/configSlice";
import { myApplicationList } from "./store/slice/applicationSlice";
import { removeUser, saveUserData } from "./store/slice/userSlice";
import Header from "./Components/Header/header";
import SideBar from "./Components/SideBar/sidebar";
import FullScreenLoader from "./Components/FullScreenLoader/fullScreenLoader";
import {
  getAllCategoryList,
  getAllSkillStream2DTags,
  getAllXRModuleTags,
  getAssetTagsList,
} from "./Components/utils";
import { PageTitleProvider } from "./Components/PageTitleContext";
import Layout from "./ApplicationLayout/Layout.js";
import { CONTENT_2D, CONTENT_3D, CONTENT_AR, CONTENT_CATEGORY, CONTENT_ENVIRONMENT, CONTENT_XR } from "./constant/Permissions.js";

const App = () => {
  const dispatch = useDispatch();
  const [darkTheme, setDarkTheme] = useState(true);
  const [sideBar, setSideBar] = useState(false);
  const [defaultRoute, setDefaultRoute] = useState("");
  const [loading, setLoading] = useState(true);
  const configData = useSelector((state) => state.configSlice);

  const getConfigurationData = async () => {
    try {
      const { data } = await axios.get(`${UNO_URL}/api/application/configuration/${applicationId}`);
      const config = { ...data.data.data };
      // config.UNO_URL = "http://localhost:3003";
      // config.SSO_URL = "http://localhost:5000";

      dispatch(saveConfig({ data: config }));
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getConfigurationData();
  }, []);

  const fetchApplication = async (token) => {
    try {
      var { data } = await axios.get(`${configData?.config?.UNO_URL}/api/application/mine`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      dispatch(myApplicationList(data.data));
    } catch (error) {
      console.log(error);
    }
  };

  const getUserDetail = async (config) => {
    const urlParams = new URLSearchParams(window.location.search);
    const _tokenParam = urlParams.get("referrer");
    let token = "";
    if (_tokenParam) {
      const decoded = jwtDecode(_tokenParam);
      localStorage.setItem("token", decoded.token);
      token = decoded.token;
    } else if (localStorage.getItem("token")) {
      token = localStorage.getItem("token");
    } else {
      const payload = {
        origin: window.location.origin,
        redirectUri: window.location.pathname,
      };
      const token = jwtEncode(payload, "");
      return (window.location.href = `${redirectUrl}?referrer=${token}`);
    }
    await axios
      .get(`${configData.config.UNO_URL}/api/user/me`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        if (response?.status === 200) {
          const { user, token: newToken } = response.data.data;

          const permissionRouteMap = [
            { permission: CONTENT_XR, route: "/dashboard/xr" },
            { permission: CONTENT_3D, route: `/dashboard/3d/${configData.config["3dAssetsId"]}` },
            { permission: CONTENT_ENVIRONMENT, route: "/dashboard/environments" },
            { permission: CONTENT_2D, route: "/dashboard/2d/lms" },
            { permission: CONTENT_CATEGORY, route: "/categories" },
            { permission: CONTENT_AR, route: "/ar/list" },
          ];

          const matchedRoute = permissionRouteMap.find((item) =>
            user.permissions.includes(item.permission)
          );
          if (matchedRoute) setDefaultRoute(matchedRoute.route);

          localStorage.setItem("token", newToken);
          const data = { token: newToken, user };

          fetchApplication(newToken);
          dispatch(saveUserData(data));
          setLoading(configData.loading);
          getAllXRModuleTags();
          getAllSkillStream2DTags();
          getAssetTagsList(config.assetFilterId);
          getAllCategoryList(config.categoryFilterId);
        }
      })
      .catch((err) => {
        dispatch(removeUser());
        localStorage.clear();
        sessionStorage.clear();
        const payload = {
          origin: window.location.origin,
          redirectUri: window.location.pathname,
        };
        const token = jwtEncode(payload, "");
        window.location.href = `${redirectUrl}?referrer=${token}`;
        console.log(err);
      });
  };

  useEffect(() => {
    if (configData.loading === false) {
      getUserDetail(configData.config);
    }
  }, [configData]);

  return (
    <>
      <PageTitleProvider>
        {loading ? (
          <FullScreenLoader loading={loading} />
        ) : (
          <div className={darkTheme ? "night" : ""}>
            <BrowserRouter>
              <Header darkTheme={darkTheme} setDarkTheme={setDarkTheme} sideBar={sideBar} setSideBar={setSideBar} />
              <div style={{ display: "flex" }}>
                <SideBar sideBar={sideBar} setSideBar={setSideBar} />

                <div className={sideBar ? "mainbody sideactive" : "mainbody"}>
                  <Layout defaultRoute={defaultRoute} />
                </div>

              </div>
            </BrowserRouter>
          </div>
        )}
      </PageTitleProvider>
    </>
  );
};

export default App;